<mat-dialog-content>
  <h4 class="title">Folder Size Report</h4>
  
  <div>
    <p>This report provides detailed information about size of contents stored under each folder that would be restored using full, not point-in-time restore.
      It can be used to suggest the strategy to a partner how they would restore this mailbox folder-by-folder if size of contents backed up for this mailbox exceeds 100 GB.</p>
    <p>Before you proceed, please carefully read the information below:</p>
    <ol>
      <li>Data for the report is taken from <b>Elasticsearch</b>. It is recommended to <b>reindex</b> this resource before generating the report to ensure accuracy of data included in the report.</li>
      <li>The report can be shared with a partner. Please make sure to remove the <b>Item count</b> column from the report to avoid any possible questions from the partner.
        If some items are skipped during a restore, there will be a discrepancy in the number of items in this report and the restore summary one, which can be downloaded in Backup Portal.</li>
    </ol>
    <p><b>Please Note:</b> For accounts with a large number of folders or significant data, the export process may take longer or timeout.</p>
  </div>

  <div>
    <div *ngIf="isLoading" class="loading-dialog">
      <mat-spinner class="spinner" diameter="30"></mat-spinner>
      <span>Downloading...</span>
    </div>

    <div class="dialog-buttons">
      <button
        mat-raised-button
        [disabled]="isLoading"
        [mat-dialog-close]="true">
        Close
      </button>
      <button
        mat-raised-button
        (click)="onExportFolderSizeSummary()"
        [disabled]="isLoading">
        Download Report
      </button>
    </div>
  </div>
  <div *ngIf="errorMessage" class="error-message">
    <mat-icon color="warn">Error</mat-icon>
    {{ errorMessage }}
  </div>
</mat-dialog-content>
